module.exports = __webpack_public_path__ + "img/result-2H.b9dd25d3.png";